import React, { useCallback } from 'react';

import { Typography, useMediaQuery } from '@mui/material';
import { IconMenuDeep } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/buttons/Button';
import { MEDIA_QUERY } from '@/constants/media-query';
import { theme } from '@/theme';

import { usePageContainerContext } from '../../providers/PageContainerContext';
import { NavSelectorLanguage } from './NavSelectorLanguage';
import { NavSelectorMarket } from './NavSelectorMarket';
import { NavSelectorUser } from './NavSelectorUser';
import { PageBreadcrumbs } from './PageBreadcrumbs';
import { StyledHeader, StyledNav, StyledTitle, StyledWrapper } from './PageHeading.styles';

export interface PageHeadingProps {
    isSidebarVisible: boolean;
    setSidebarVisible: (isOpened: boolean) => void;
}

export const PageHeading = ({ isSidebarVisible, setSidebarVisible }: PageHeadingProps) => {
    const { t } = useTranslation();
    const isMobileSize = useMediaQuery(MEDIA_QUERY.ONLY_XS);

    const { pageTitle } = usePageContainerContext();

    const handleSetSidebarVisible = useCallback(() => {
        setSidebarVisible(true);
    }, [setSidebarVisible]);

    return (
        <StyledWrapper>
            <StyledHeader>
                <StyledTitle>
                    {!isMobileSize && isSidebarVisible ? null : (
                        <Button
                            aria-label={t('sidebar')}
                            type="text-dark"
                            icon={<IconMenuDeep size={18} style={{ transform: 'scaleX(-1) translateX(.333rem)' }} />}
                            onClick={handleSetSidebarVisible}
                            width="auto"
                            sx={{ paddingLeft: '0 !important', paddingRight: '0 !important' }}
                        />
                    )}
                    <Typography variant="h1" sx={{ color: theme.palette.headings.dark }}>
                        {pageTitle}
                    </Typography>
                </StyledTitle>
                <PageBreadcrumbs />
            </StyledHeader>
            <StyledNav>
                <NavSelectorUser />
                <NavSelectorMarket />
                <NavSelectorLanguage />
            </StyledNav>
        </StyledWrapper>
    );
};
